// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__epHUi","inputWrap":"CustomTip_inputWrap__54F4Z"};